import {getMultiplePriceChangeInclusiveFields} from '../../../shared/shared-utils/price/multiple-price-change.utils';

/**
 * Editable stock-manager fields, kept out of the column-def module so NgRx
 * reducers and selectors do not pull in cell editors (that import cycle
 * initialises settings selectors before price-band selectors exist).
 */
export const editableFields: string[] = [
  'desc',
  'alternateDescription',
  'barcode',
  'multipleBarcodes',
  'binL',
  'dep',
  'subDep',
  'genCode',
  'onHoldCode',
  '_tags',
  'ordLvl',
  'maxOrderLevel',
  'minOrderLevel',
  'orderQty',
  'packSize',
  'sellPriIncl1',
  'nominalGP',
  'recommendedGP',
  'suppCode',
  'regularSuppCode',
  'multipleSuppliers',
  'lineColourCode',
  'latestCost',
  ...getMultiplePriceChangeInclusiveFields(),
];
